import Cache from 'admin/editor/cache';
import { debounce } from 'vendor/lodash.debounce';

export default class CollapsibleElement {
  constructor(options) {
    this.learnEditor = options.editor;
    this.savedQuestion = null;
    this.savedContent = null;
    this.activeElementId = null;
    this.activePosition = null;

    this.init();
  }

  init() {
    const ua = navigator.userAgent,
      action = (ua.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on('click', '.add-build-collapsible', this.newElement.bind(this));
    $(document).on(action, '.submit-build-collapsible', this.submitElement.bind(this));
    $(document).on(action, '.cancel-build-collapsible', this.cancelElement.bind(this));
    $(document).on(action, '.delete-build-collapsible', this.deleteElement.bind(this));
    $(document).on(action, '.build-faq', this.editElement.bind(this));

    this.cache = new Cache('collapsible');
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-collapsible" href="#"><i class="fa fa-question-circle"></i>Collapsible</a>';
  }

  newElement(event) {
    event.preventDefault();

    let link = $(event.currentTarget);

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.savedQuestion = null;
    this.savedContent = null;

    const cachedQuestion = this.cache.get('question') || { title: "" };
    const cachedContent = this.cache.get('content');

    this.insertCollapsible(link.closest('.button-bar, .bottom-button-bar'), cachedQuestion, cachedContent);
    this.learnEditor.editing();
  }

  async submitElement(event) {
    event.preventDefault();
    const $element = $(event.currentTarget).closest('.build-faq-wrapper');


    const question = await this.processQuestion($('.build-input').val());

    // const title = $('.build-input').val();
    const content = tinymce.activeEditor.getContent();

    this.learnEditor.disable_text_editor($('.build-textarea'));

    this.savedQuestion = null;
    this.savedContent = null;
    this.addFaq($element, question, content, this.activeElementId, this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Added Collapsible Element");
  }

  async processQuestion(value) {
    return $.post('/elements/markdown.json', { markdown: value })
            .then(response => ({ title: value, html: response.content }))
  }

  processMarkdown(value) {
    return $.post('/elements/markdown.json', { markdown: value })
  }

  editElement(event) {
    event.preventDefault();
    //or if an editor is already present
    if(this.learnEditor.is_editor_enabled()) { //only one editor should be enabled at a time
      return;
    }

    let $element = $(event.currentTarget);

    const question = {
      title: $(".question", $element).data('title'),
      html: $(".question", $element).html(),
    }

    // legacy titles may be empty, copy from html on edit
    question.title = question.title ? question.title : question.html;

    const content = $(".answer", $element).html();

    const cachedQuestion = this.cache.get('question');
    const cachedContent = this.cache.get('content');

    //backup the text, save it in case of cancelling
    this.savedQuestion = question;
    this.savedContent = content;
    this.activeElementId = $element.closest('.build-faq').attr('id');
    this.activePosition = $element.closest('.build-faq').data('position');
    this.insertCollapsible($element, cachedQuestion || question, cachedContent || content);
    this.learnEditor.centerInView($('.build-faq-wrapper'));
    this.learnEditor.editing();
  }

  cancelElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    this.learnEditor.disable_text_editor($('.build-textarea'));

    //restore with global saved text
    this.addFaq($element.closest('.build-faq-wrapper'),
      this.savedQuestion,
      this.savedContent,
      this.activeElementId,
      this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.finishEditing();
    this.cache.delete();
  }

  deleteElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);


    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    this.learnEditor.disable_text_editor($('.build-textarea'));

    $element.closest('.build-faq-wrapper').remove();

    this.savedQuestion = null;
    this.savedContent = null;
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Deleted  Side-by-Side Element");
    this.cache.delete();
  }

  insertCollapsible($element, question, content) {
    const buildText = this.buildCollapsible(question, content);

    $element.hide();
    let $build_text = $(buildText).hide();
    $element.replaceWith($build_text);
    this.learnEditor.enable_text_editor($('#editor'));
    $('.build-faq-wrapper').show();

    this.watchState($build_text);
    this.learnEditor.centerInView($('.build-faq-wrapper'));
  }

  watchState($element) {
    var saveState = function(event) {
      const question = { title: $('.build-input').val() };
      const content = tinymce.activeEditor.getContent();
      this.cache.save({ question: question, content: content });
    }

    $element.find('.build-input').on('keyup', debounce(saveState.bind(this), 500));
    tinymce.activeEditor.on('keyup', debounce(saveState.bind(this), 500));
  }

  buildCollapsible(question, content) {
    let title = question.title || "Enter Collapsible Title";
    content = content || "";

    let buildText =
      ["<div class='row-fluid build-faq-wrapper'>",
        "<label for='build-content'>Enter title text (supports inline markdown)</label>",
        "<input class='build-input span12' style='display=block;' value='" + title.replace(/'/g, "&#39;").trim() + "' />",
        "<label for='editor'>Enter main collapsible content</label>",
        "<div class='faq-editor'>",
          "<textarea id='editor' class='build-textarea' style='display=block;'>",
            content,
          "</textarea>",
        "</div>",
        "<div class='clear'></div>",
        "<div class='editor-buttons'>",
          "<button class='delete-build-collapsible delete'>Delete</button>",
          "<button class='cancel-build-collapsible cancel'>Cancel</button>",
          "<button class='submit-build-collapsible save'>Save</button>",
        "</div>",
        "</div>"
      ].join('\n');


    let $buildText = $(buildText);

    return $buildText;
  }

  addFaq($element, question, content, id, position) {
    if (question && content) {
      var embedHtml = [
        "<div id='" + (id || "") + "'  class='element row-fluid faq-element build-faq' data-position='" + (position || "") + "'>",
          `<i class='fa fa-question prompt-icon'></i>`,
          `<div class="question" data-title="${question.title}">${question.html}</div>`,
          '<div class="answer">',
            content,
          '</div>',
        '</div>'
        ].join('');

      $element.replaceWith(embedHtml);
    } else {
      $element.remove();
    }
  }

  deleteCollapsible($element) {
    let $parent_table = $element.parents('table');
    // see if issue with collapsible element
    const row_count = $parent_table.find('.build-row, .build-row-wrapper').length;

    if (row_count <= 1) {
      //only the selected row, and the add-row links row left, delete the table
      $parent_table.remove();
    } else {
      $element.remove();
    }
  }
}
